import React from "react";
import CBRProgHero from "../../../assets/images/CBRProgHero.svg"; // Fallback image

const Hero: React.FC = () => {
  return (
    <section className="relative w-full overflow-hidden bg-white pt-4 px-4">
      {/* Background circles */}
      <div className="absolute top-0 right-0 -mr-40 -mt-20 w-[600px] h-[600px] rounded-full border-[40px] border-blue-50/50 opacity-50 z-0"></div>
      <div className="absolute top-0 right-10 -mr-20 -mt-10 w-[500px] h-[500px] rounded-full border-[20px] border-blue-50/30 opacity-50 z-0"></div>

      <div className="container mx-auto px-4 lg:px-0 pt-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">

          {/* Left Content */}
          <div className="w-full lg:w-1/2 max-w-xl">
            <p className="text-navYellow font-medium text-xl tracking-wider mb-4">
              Transforming lives through the Word
            </p>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-darkBlue mb-8">
              The <span className="text-navYellow">CBR</span> Program
            </h1>
            <p className="text-gray-600 text-lg mb-16 leading-relaxed">
              A comprehensive 7 months journey designed to help you develop a consistent, systematic Bible reading habit that transforms your life.
            </p>

            <div className="flex justify-between">
              <div className="flex flex-col items-start">
                <span className="text-mainBlue font-semibold text-3xl">7</span>
                <span className="text-mainBlue text-sm">Months</span>
              </div>
              <div className="flex flex-col items-start">
                <span className="text-mainBlue font-semibold text-3xl">7</span>
                <span className="text-mainBlue text-sm">Lessons</span>
              </div>
              <div className="flex flex-col items-start">
                <span className="text-mainBlue font-semibold text-3xl">Free</span>
                <span className="text-mainBlue text-sm">Course</span>
              </div>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end">
            <img
              src={CBRProgHero}
              alt="CBR Program Study"
              className="rounded-2xl h-[320px] md:h-[420px] lg:h-[550px]"
            />
          </div>
        </div>
      </div>

      {/* Bottom Blue Banner */}
      <div className="w-full bg-[#7590AB] mx-auto py-10 px-4 lg:px-0">
        <div className="container mx-auto px-4 lg:px-0">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="pl-6 py-2 border-l-4 border-blue-300">
              <h3 className="text-white font-bold text-2xl mb-2">Plenaries</h3>
              <p className="text-blue-100 text-lg">In-person or online sessions for teaching, instruction, and evaluation</p>
            </div>
            <div className="pl-6 py-2 border-l-4 border-blue-300">
              <h3 className="text-white font-bold text-2xl mb-2">GOAL</h3>
              <p className="text-blue-100 text-lg">Groups Open Accountability Life (GOAL) is our training norm</p>
            </div>
            <div className="pl-6 py-2 border-l-4 border-blue-300">
              <h3 className="text-white font-bold text-2xl mb-2">Discipline</h3>
              <p className="text-blue-100 text-lg">Early rising and Bible reading become natural in just a few months</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
